import { render } from "./EditReturn.vue?vue&type=template&id=2875c7d7&ts=true"
import script from "./EditReturn.vue?vue&type=script&lang=ts"
export * from "./EditReturn.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__